import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

export default function FloatingWhatsApp() {
  const whatsappNumber = '+905314037309';
  const message = 'Merhaba, etkinlik hakkında bilgi almak istiyorum.';
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-cta-button"
      aria-label="WhatsApp'tan Yaz"
      className="fixed bottom-24 right-5 z-40 flex items-center gap-2 rounded-full px-4 py-3 shadow-2xl group"
      style={{
        background: '#25D366',
        boxShadow: '0 8px 32px rgba(37,211,102,0.3)',
      }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.05, boxShadow: '0 12px 40px rgba(37,211,102,0.4)' }}
      whileTap={{ scale: 0.97 }}
    >
      <MessageCircle size={20} className="text-white flex-shrink-0" />
      <span className="text-white text-xs font-medium tracking-wide hidden sm:block">WhatsApp</span>
    </motion.a>
  );
}
